import React, { useEffect, useState } from "react";
import { ShopBanner } from "./ShopBanner";
import { assets, fmt } from "../../mock";
import { useCategories } from "../../lib/categories";
import api from "../../lib/api";
import { useCart } from "../../context/CartContext";
import ProductDialog from "./ProductDialog";
import { FeaturedCarousel } from "./FeaturedCarousel";
import { Link, useNavigate } from "react-router-dom";
import { Lock, ArrowRight, Calculator } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export const RentChip = ({ p, light = true }) => {
  const navigate = useNavigate();
  if (p.kind !== "hardware") return null;
  const net = p.price > 0 && !p.price_hidden ? Math.round(p.price / 1.22) : 0;
  const go = (e) => { e.preventDefault(); e.stopPropagation(); navigate(`/noleggio-finanziamenti${net ? `?valore=${net}` : ""}#calcolo`); };
  return (
    <span role="link" tabIndex={0} onClick={go} onKeyDown={(e) => e.key === "Enter" && go(e)} className={`mt-1.5 cursor-pointer inline-flex items-center gap-1 text-[11px] font-bold rounded-full px-2 py-0.5 transition-colors duration-200 ${light ? "bg-white/15 text-white hover:bg-white/25" : "bg-[#CF1072]/10 text-[#CF1072] hover:bg-[#CF1072]/20"}`} data-testid={`rent-chip-${p.product_id}`}>
      <Calculator className="w-3 h-3" />{net ? `da ${fmt(net * 0.023)}/mese` : "Calcola il canone"}
    </span>
  );
};

const PriceInner = ({ p, light = true }) => {
  if (p.price_hidden) return (
    <Link to="/area-clienti" onClick={(e) => e.stopPropagation()} className={`inline-flex items-center gap-1 text-[12px] mt-2 underline-offset-2 hover:underline ${light ? "text-[#ffd0e6]" : "text-[#CF1072]"}`} data-testid={`price-login-${p.product_id}`}>
      <Lock className="w-3 h-3" /> Accedi per vedere il prezzo
    </Link>
  );
  if (p.price == null) return null;
  return (
    <div className={`text-[14px] mt-2 ${light ? "text-white" : "text-[#1d1e20] font-bold"}`}>
      {p.old_price && <span className="line-through opacity-60 mr-2 font-normal">{fmt(p.old_price)}</span>}
      <span>{p.from_price ? "Da " : ""}{fmt(p.price)}</span>
      {p.rent_monthly != null && <span className={`block text-[11px] font-normal ${light ? "text-white/70" : "text-[#1A237E]"}`}>o da {fmt(p.rent_monthly)}/mese</span>}
    </div>
  );
};

const Price = ({ p, light = true }) => <><PriceInner p={p} light={light} />{p.rent_monthly == null && <RentChip p={p} light={light} />}</>;

export { Price };

export const DEDICATED = { cassetti: ["/pagamento-automatico", "Vai alle casse automatiche VNE con filtri"], misuratori: ["/soluzioni-fiscali", "Vai alla pagina Soluzioni fiscali"], software: ["/software", "Scopri tutti i software per settore"] };
export const productLink = (p) => (p.kind === "hardware" ? `/prodotti/${p.slug}` : p.slug ? `/software/${p.slug}` : null);

const Shop = () => {
  const [selected, setSelected] = useState(null);
  const categories = useCategories();
  const { add } = useCart();
  const [products, setProducts] = useState(null);
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    api.get("/products").then(({ data }) => setProducts(data)).catch(() => setProducts([]));
  }, [user, loading]);

  const open = (p) => { const to = productLink(p); to ? navigate(to) : setSelected(p); };
  const cats = categories.filter((c) => c.id !== "all" && products?.some((p) => p.categories.includes(c.id)));

  return (
    <section id="negozio" className="relative" data-testid="shop-section">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${assets.shopBg})` }} />
      <div className="absolute inset-0 bg-[#0b1220]/55" />
      <div className="relative max-w-[1224px] mx-auto px-4 py-14">
        <ShopBanner testid="shop-preview" />
        <div className="flex flex-wrap gap-2 mt-6" data-testid="shop-preview-categories">
          {cats.map((c) => (
            <Link key={c.id} to={`/negozio?cat=${c.id}`} className="h-[36px] px-4 rounded-full bg-white/10 backdrop-blur-md border border-white/25 text-white text-[13px] flex items-center gap-2 hover:bg-white/20 transition-colors duration-200" data-testid={`shop-preview-cat-${c.id}`}>
              {c.label} <span className="text-white/60 text-[11px]">{products.filter((p) => p.categories.includes(c.id)).length}</span>
            </Link>
          ))}
        </div>
        {!user && (
          <Link to="/area-clienti" className="mt-6 inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-3 text-white text-[14px] hover:bg-white/15 transition-colors duration-200" data-testid="shop-login-banner">
            <Lock className="w-5 h-5 text-[#ffd0e6] shrink-0" /><span><strong>Prezzi riservati ai clienti registrati.</strong> Accedi o registrati gratis per vedere prezzi e offerte.</span>
          </Link>
        )}
        {products && <div className="mt-10"><FeaturedCarousel products={products} onOpen={open} onAdd={add} /></div>}
      </div>
      <ProductDialog product={selected} onClose={() => setSelected(null)} />
    </section>
  );
};

export default Shop;
